import { render, staticRenderFns } from "./saintbrand-shipping.vue?vue&type=template&id=7bccca1d&"
import script from "./saintbrand-shipping.vue?vue&type=script&lang=js&"
export * from "./saintbrand-shipping.vue?vue&type=script&lang=js&"
import style0 from "./saintbrand-shipping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports